import _ from 'lodash';
import React, { Dispatch } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { DropdownItemProps } from 'react-bootstrap/esm/DropdownItem';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { AnyType } from '../interfaces';
import { AppRootState, navigateToTenancyLink } from '../redux';

export const clientApplicationNameSelector = (state: AppRootState) => state.app.config?.applicationName;
export const clientApplicationVersionSelector = (state: AppRootState) => state.app.config?.name;
export const clientIdSelector = (state: AppRootState) => state.app.config?.programId;

export const featureGridColumnsSelector = (featureKey: string) => (state: AppRootState) =>
  (((state.app?.entities?.features as AnyType) ?? {})[featureKey ?? ''] as AnyType)?.data?.columns;

export const getFeatureGridColumnProps = ({ headerName, hide }: AnyType = {}) => ({ headerName, hide });

export const renderTenancyLinksAsNavItems = (dispatch: Dispatch<AnyType>, links: AnyType) => {
  return links?.map((link: AnyType) => renderTenancyNavItem(dispatch, link));
};

export const renderTenancyNavItem = (
  dispatch: Dispatch<AnyType>,
  link: AnyType,
  navItemProps: DropdownItemProps = {}
) => {
  const kebabLabel = _.kebabCase(link.label);

  return (
    <FeatureGuard key={kebabLabel} contentKey={link.featureKey}>
      <NavDropdown.Item
        {...navItemProps}
        data-testid={`cmx__${kebabLabel}`}
        eventKey={kebabLabel}
        onClick={() => dispatch(navigateToTenancyLink(link))}>
        <NavDropdown.ItemText className='ps-0'>{link.label}</NavDropdown.ItemText>
      </NavDropdown.Item>
    </FeatureGuard>
  );
};
